// 디지털 콘텐츠 이미지들 import
import imgMr from "../image/digital-content/mr-mirror.png"; // MR미러
import imgMr1 from "../image/digital-content/mr-trampoline.png"; // MR트램폴린
import imgVr from "../image/digital-content/vr-laser-shooting.jpg"; // VR레이저슈팅
import imgVr1 from "../image/digital-content/vr-ball-pool.jpg"; // VR볼풀장
import imgVr2 from "../image/digital-content/vr-slide.png"; // VR슬라이드
import imgVr3 from "../image/digital-content/vr-coloring.png"; // VR컬러링
import imgVr4 from "../image/digital-content/vr-floor.png"; // VR플로어
import imgXr from "../image/digital-content/xr-multi-floor.png"; // XR멀티플로어
import imgXr1 from "../image/digital-content/xr-table.png"; // XR테이블
import imgFaceFilter from "../image/digital-content/face-filter.png"; // 페이스필터

// 놀이시설 이미지들 import
import imgPlayRoom1 from "../image/play-facilities/hinoki-playroom.jpg"; // 편백나무방
import imgPlayRoom2 from "../image/play-facilities/mirror-playroom.jpg"; // 거울놀이방
import imgPrincessRoom from "../image/play-facilities/princess-dress-room.jpg"; // 공주놀이옷방
import imgPlayRoom4 from "../image/play-facilities/fishing-playroom.jpg"; // 낚시놀이방
import imgPlayRoom5 from "../image/play-facilities/free-game-zone.jpg"; // 무료게임존
import imgPlayRoom6 from "../image/play-facilities/jungle-gym.png"; // 정글짐
import imgPlayRoom7 from "../image/play-facilities/kitchen-playroom.jpg"; // 주방놀이방

// 부대시설 이미지들 import
import imgStore from "../image/amenities/store.png"; // 매점
import imgNursing from "../image/amenities/nursing-room.jpg"; // 수유실
import imgCafe from "../image/amenities/cafe-zone.jpg"; // 카페존
import imgTinyCenter from "../image/amenities/tiny-center.png"; // 타이니센터
import imgPartyRoom from "../image/amenities/party-room.jpg"; // 파티룸
import imgPrivateRoom from "../image/amenities/private-room.jpg"; // 프라이빗룸

export interface FacilityItem {
  id: string;
  title: string;
  description: string;
  category: "physical" | "digital" | "facilities" | "all";
  image: string;
  features?: string[];
}

export const facilityData: FacilityItem[] = [
  // 디지털 콘텐츠 (10개)
  {
    id: "mr-mirror",
    title: "MR미러",
    description:
      "혼합현실 기술을 활용한 인터랙티브 거울 체험입니다. 거울 속 가상 캐릭터와 함께 다양한 게임을 즐길 수 있습니다.",
    category: "digital",
    image: imgMr,
    features: [
      "캐릭터변신",
      "인터랙티브게임",
      "모션인식",
      "상상력발달",
    ],
  },
  {
    id: "mr-trampoline",
    title: "MR트램폴린",
    description:
      "트램폴린 위에서 뛰어오르며 혼합현실 게임을 체험할 수 있습니다. 점프할 때마다 화면에 다양한 효과가 나타납니다.",
    category: "digital",
    image: imgMr1,
    features: [
      "트램폴린",
      "캐릭터변신",
      "균형감각",
      "체력단련",
    ],
  },
  {
    id: "vr-laser-shooting",
    title: "VR레이저슈팅",
    description:
      "가상현실 속에서 레이저 건을 이용해 다양한 타겟을 맞추는 슈팅 게임입니다. 몰입감 있는 VR 체험을 제공합니다.",
    category: "digital",
    image: imgVr,
    features: [
      "집중력훈련",
      "반응속도향상",
      "다양한스테이지",
      "성취감체험",
    ],
  },
  {
    id: "vr-ball-pool",
    title: "VR볼풀장",
    description:
      "스크린에 볼을 던져 점수를 획득해보세요. 협력 미션을 수행하며 전략적 사고력과 협동심을 기를 수 있습니다.",
    category: "digital",
    image: imgVr1,
    features: [
      "인터랙티브볼풀",
      "전략적사고",
      "협력게임",
      "안전한체험",
    ],
  },
  {
    id: "vr-slide",
    title: "VR슬라이드",
    description:
      "미끄럼틀을 타고 내려오면서 바닥에 나타나는 다양한 효과를 볼 수 있습니다. 다양한 테마의 디지털 세계를 경험하며 모험심을 기를 수 있어요.",
    category: "digital",
    image: imgVr2,
    features: [
      "다양한배경",
      "실감체험",
      "디지털미끄럼틀",
      "스릴감제공",
    ],
  },
  {
    id: "vr-coloring",
    title: "VR컬러링",
    description:
      "체험지에 원하는 색깔로 색칠하고 스캔하면 벽면 스크린에 나타나요. 직접 칠한 캐릭터가 3D 세계에서 살아 움직이는 마법같은 경험을 통해 창의력을 기를 수 있습니다.",
    category: "digital",
    image: imgVr3,
    features: [
      "디지털컬러링",
      "창작체험",
      "창의성개발",
      "3D구현",
    ],
  },
  {
    id: "vr-floor",
    title: "VR플로어",
    description:
      "바닥 전체가 인터랙티브VR 체험공간입니다. 발걸음에 따라 다양한 시각 효과와 게임을 즐길 수 있습니다.",
    category: "digital",
    image: imgVr4,
    features: [
      "반응형바닥",
      "발걸음인식",
      "시각효과",
      "협동게임",
    ],
  },
  {
    id: "xr-multi-floor",
    title: "XR멀티플로어",
    description:
      "여러 명이 동시에 참여할 수 있는 확장형 플로어 콘텐츠입니다. 팀워크와 협동심을 기를 수 있는 다양한 게임을 제공합니다.",
    category: "digital",
    image: imgXr,
    features: [
      "다인플레이",
      "협동게임",
      "팀워크향상",
      "실시간반응",
    ],
  },
  {
    id: "xr-table",
    title: "XR테이블",
    description:
      "테이블 위에 펼쳐지는 인터렉티브 게임 콘텐츠입니다. 손동작으로 조작하며 다양한 게임을 즐길 수 있습니다.",
    category: "digital",
    image: imgXr1,
    features: [
      "테이블게임",
      "손동작인식",
      "소통능력향상",
      "집중력향상",
    ],
  },
  {
    id: "face-filter",
    title: "페이스필터",
    description:
      "얼굴 인식 기술을 활용한 재미있는 필터 체험입니다. 디즈니 캐릭터로 변신해 볼 수 있습니다.",
    category: "digital",
    image: imgFaceFilter,
    features: [
      "얼굴인식",
      "캐릭터변신",
      "사진촬영",
      "다양한캐릭터",
    ],
  },

  // 놀이시설 (7개)
  {
    id: "cypress-room",
    title: "편백나무방",
    description:
      "편백나무큐브가 가득한 자연친화적인 놀이공간입니다. 편백나무의 피톤치드 효과를 함께 누릴 수 있습니다.",
    category: "physical",
    image: imgPlayRoom1,
    features: [
      "힐링공간",
      "피톤치드효과",
      "자연친화적",
      "안전한놀이",
    ],
  },
  {
    id: "mirror-room",
    title: "거울놀이방",
    description:
      "벽면이 거울로 이루어진 신비로운 놀이공간입니다. 아이들이 자신의 모습을 관찰하며 상상력을 키울 수 있습니다.",
    category: "physical",
    image: imgPlayRoom2,
    features: [
      "거울놀이",
      "자아인식",
      "상상력발달",
      "공간지각",
    ],
  },
  {
    id: "princess-room",
    title: "공주놀이옷방",
    description:
      "다양한 의상과 액세서리가 준비된 역할놀이 공간입니다. 아이들이 좋아하는 캐릭터로 변신하며 창의적인 놀이를 즐길 수 있습니다.",
    category: "physical",
    image: imgPrincessRoom,
    features: [
      "역할놀이",
      "의상체험",
      "창의적놀이",
      "캐릭터변신",
    ],
  },
  {
    id: "fishing-room",
    title: "낚시놀이방",
    description:
      "낚시 체험을 할 수 있는 특별한 놀이공간입니다. 안전한 환경에서 낚시의 재미를 느끼며 집중력과 인내심을 기를 수 있습니다.",
    category: "physical",
    image: imgPlayRoom4,
    features: [
      "낚시체험",
      "집중력향상",
      "인내심기르기",
      "성취감체험",
    ],
  },
  {
    id: "game-zone",
    title: "무료게임존",
    description:
      "다양한 아케이드 게임을 무료로 즐길 수 있는 공간입니다. 클래식한 게임부터 최신 게임까지 폭넓은 선택지를 제공합니다.",
    category: "physical",
    image: imgPlayRoom5,
    features: [
      "무료게임",
      "아케이드",
      "다양한선택",
      "자유체험",
    ],
  },
  {
    id: "jungle-gym",
    title: "정글짐",
    description:
      "아이들의 체력과 균형감각을 기를 수 있는 대형 정글짐입니다. 안전하게 설계되어 마음껏 오르고 내리며 모험을 즐길 수 있습니다.",
    category: "physical",
    image: imgPlayRoom6,
    features: ["체력단련", "균형감각", "모험놀이", "안전설계"],
  },
  {
    id: "kitchen-room",
    title: "주방놀이방",
    description:
      "주방을 축소한 놀이공간에서 요리 놀이를 즐길 수 있습니다. 아이들이 요리사가 되어 창의적인 역할 놀이를 경험할 수 있습니다.",
    category: "physical",
    image: imgPlayRoom7,
    features: [
      "요리놀이",
      "역할체험",
      "창의적활동",
      "실감나는체험",
    ],
  },

  // 부대시설 (6개)
  {
    id: "store",
    title: "매점",
    description:
      "다양한 간식과 음료, 생필품을 구입할 수 있는 편의점입니다. 아이들이 좋아하는 간식부터 필수용품까지 모두 준비되어 있습니다.",
    category: "facilities",
    image: imgStore,
    features: [
      "편의점운영",
      "다양한간식",
      "음료판매",
      "에너지충전",
    ],
  },
  {
    id: "nursing-room",
    title: "수유실",
    description:
      "엄마와 아기를 위한 편안하고 깨끗한 수유공간입니다. 프라이빗한 환경에서 안심하고 수유할 수 있도록 잘 갖춰져 있습니다.",
    category: "facilities",
    image: imgNursing,
    features: [
      "프라이빗공간",
      "깨끗한환경",
      "편안한시설",
      "육아편의",
    ],
  },
  {
    id: "cafe-zone",
    title: "카페존",
    description:
      "부모님들이 휴식을 취하며 커피와 음료를 즐길 수 있는 카페 공간입니다. 아이들을 지켜보며 편안한 시간을 보낼 수 있습니다.",
    category: "facilities",
    image: imgCafe,
    features: [
      "커피음료",
      "휴식공간",
      "아이관찰",
      "편안한분위기",
    ],
  },
  {
    id: "tiny-center",
    title: "타이니센터",
    description:
      "아이들이 직접 물건을 고르는 체험을 할 수 있는 미니 상점입니다.",
    category: "facilities",
    image: imgTinyCenter,
    features: [
      "미니상점",
      "경제교육",
      "독립심기르기",
      "실생활체험",
    ],
  },
  {
    id: "party-room",
    title: "파티룸",
    description:
      "생일파티나 특별한 행사를 위한 전용 파티룸입니다. 예약을 통해 소중한 순간을 더욱 특별하게 만들어드립니다.",
    category: "facilities",
    image: imgPartyRoom,
    features: ["생일파티", "예약전용", "특별한날", "단체이용"],
  },
  {
    id: "private-room",
    title: "프라이빗룸",
    description:
      "가족만의 시간을 보내고 싶을 때 이용할 수 있는 프라이빗 공간입니다. 조용하고 편안한 환경에서 시간을 보낼 수 있습니다.",
    category: "facilities",
    image: imgPrivateRoom,
    features: [
      "개별공간",
      "우리끼리",
      "조용한환경",
      "편안한시설",
    ],
  },
];

export const facilityCategories = [
  { id: "all", label: "전체" },
  { id: "physical", label: "놀이시설" },
  { id: "digital", label: "디지털 콘텐츠" },
  { id: "facilities", label: "부대시설" },
];